import { render, staticRenderFns } from "./MarkdownEditor.pug?vue&type=template&id=647b4d7e&lang=pug&external"
import script from "./MarkdownEditor.js?vue&type=script&lang=js&external"
export * from "./MarkdownEditor.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports